import { Link } from 'react-router-dom';
import { NAV, POLICY_LINKS } from '../constants/content';
import {
  FOOTER_DISCLAIMER,
  SITE_DOMAIN,
  SITE_NAME,
  SUPPORT_EMAIL,
} from '../constants/site';

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="fm-footer">
      <div className="fm-container">
        <div className="fm-footer__inner">
          <div>
            <Link to="/" className="fm-logo">
              <span className="fm-logo__mark" aria-hidden />
              {SITE_NAME}
            </Link>
            <p>
              Design software and digital marketing tools for freelancers,
              studios, and growing brands — with clear licensing and fast
              delivery.
            </p>
          </div>

          <div>
            <h4>Explore</h4>
            <ul>
              {NAV.map((item) => (
                <li key={item.href}>
                  <Link to={item.href}>{item.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4>Policies</h4>
            <ul>
              {POLICY_LINKS.map((item) => (
                <li key={item.to}>
                  <Link to={item.to}>{item.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4>Contact</h4>
            <ul>
              <li>
                <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="fm-footer__disclaimer">
          <h4>Disclaimer</h4>
          {FOOTER_DISCLAIMER.map((paragraph) => (
            <p key={paragraph.slice(0, 40)}>{paragraph}</p>
          ))}
        </div>

        <div className="fm-footer__bottom">
          © {year} {SITE_NAME} ({SITE_DOMAIN}). All rights reserved.
        </div>
      </div>
    </footer>
  );
}
